"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetClosestStores = void 0;

var _reactQuery = require("react-query");

var _types = require("../types");

var _api = require("../api");

var _ = require("../");

var useGetClosestStores = function useGetClosestStores(query) {
  var addressObject = (0, _.getAddressObject)(query);
  return (0, _reactQuery.useQuery)([_types.QueryKeys.GetClosestStores, query], function () {
    return (0, _api.fetchGetClosestStores)(addressObject);
  }, {
    enabled: !!query && !!addressObject.address,
    staleTime: 30 * 1000
  });
};

exports.useGetClosestStores = useGetClosestStores;